import {
  incomes,
  scores,
  register,
  code,
  cash,
  shareData,
  ClickNum,
  cashScore,
  courseIdApi,
} from './service';
import { Effect } from 'umi';
import { Reducer } from '@@/plugin-dva/connect';

export interface scoreType {
  create_time: string;
  score: number; //抢分币金额
  resource: number; //抢分币来源 0:注册,1:分享用户下单,2:提现,3:抵现
  child_mobile: number; //子用户手机号 resource字段为0，1时补充当前字段
  order_id: string; //订单号 resource字段为1，3时补充当前字段
  invitate_order_status: number; //邀请订单状态 resource字段为1时补充当前字段 0:未确认 1:已确认 2:已取消
  invitate_order_level: number; //邀请用户下单用户与当前用户代理关系 1：一级子用户 2：二级子用户 3：三级子用户,仅resource为1时需要填写
  cash_status: number; //提现状态 user_score表resource字段为2时补充当前字段 0:未处理 1:已忽略 2:已转账待回执 3:已转账已回执 4:已转账已失败
  cash_alipay_count?: number; //用户支付宝账号 user_score表resource字段为3时补
}

export interface incomesType {
  page: number;
  perpage: number;
  total_num: number;
  data: scoreType[];
  surplus_score: number;
  register_num: number;
  order_num: number;
  today_score: number;
  un_confirm: number;
  used_score: number;
  total_score: number;
  click_num: number;
  scoreCash: number; // 可提现抢分币
  share: {
    title: string;
    content: string;
    image_url: string; //分享图片地址
    target_url: string; //识别二维码跳转页面
    share_type: string; // 分享方式:default,text,image,web,video
    share_data: string; //分享生成包含用户信息的二维码
    activity: string; //活动名称
  };
  course_id: string;
  mobile: number;
}

export interface ModelType {
  namespace: string;
  state: incomesType;
  effects: {
    fetch: Effect;
    fetchScore: Effect;
    fetchCash: Effect;
    fetchRegister: Effect;
    fetchCode: Effect;
    fetchShare: Effect;
    fetchClickNum: Effect;
    fetchScoreCash: Effect;
    fetchCourseId: Effect;
  };
  reducers: {
    save: Reducer;
    scoreData: Reducer;
    shareState: Reducer;
    ScoreCash: Reducer;
    changeCourseId: Reducer;
  };
}

const Model: ModelType = {
  namespace: 'incomes',

  state: {
    data: [],
    page: 1,
    perpage: 10,
    total_num: 0,
    surplus_score: 0,
    register_num: 0,
    order_num: 0,
    today_score: 0,
    un_confirm: 0,
    used_score: 0,
    total_score: 0,
    click_num: 0,
    scoreCash: 0,
    share: {
      title: '',
      content: '',
      image_url: '', //分享图片地址
      target_url: '', //识别二维码跳转页面
      share_type: '', // 分享方式:default,text,image,web,video
      share_data: '', //分享生成包含用户信息的二维码
      activity: '', //活动名称
    },
    course_id: '',
    mobile: 0,
  },

  effects: {
    *fetch({}, { call, put }) {
      const response = yield call(incomes);
      if (response && response.error_code === 0) {
        yield put({
          type: 'save',
          payload: response,
        });
      }
    },
    *fetchScore({ payload }, { call, put }) {
      const response = yield call(scores, payload);
      if (response && response.error_code === 0) {
        yield put({
          type: 'scoreData',
          payload: {
            page: 1,
            perpage: 10,
            ...payload,
            ...response,
          },
        });
      }
    },

    *fetchCash({ payload, callback }, { call, put }) {
      const response = yield call(cash, payload);
      if (response && response.error_code === 0) {
        if (callback) callback(response);
      }
    },

    *fetchRegister({ payload, callback }, { call, put }) {
      const response = yield call(register, payload);
      if (response && response.error_code === 0) {
        if (callback) callback(response);
      }
    },
    *fetchCode({ payload, callback }, { call, put }) {
      const response = yield call(code, payload);
      if (response && response.error_code === 0) {
        if (callback) callback(response);
      }
    },
    *fetchShare({ payload }, { call, put }) {
      const response = yield call(shareData, { activity: 'userScore' });
      if (response && response.error_code === 0) {
        yield put({
          type: 'shareState',
          payload: response,
        });
      }
    },
    *fetchScoreCash({ payload }, { call, put }) {
      const response = yield call(cashScore);
      yield put({
        type: 'ScoreCash',
        payload: response,
      });
    },

    *fetchClickNum({ payload }, { call, put }) {
      yield call(ClickNum, payload);
    },

    *fetchCourseId({ payload }, { call, put }) {
      const response = yield call(courseIdApi);
      if (response && response.error_code === 0) {
        yield put({
          type: 'changeCourseId',
          payload: {
            ...response,
            mobile: payload,
          },
        });
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload.data,
      };
    },
    shareState(state, { payload }) {
      return {
        ...state,
        share: payload.data,
      };
    },
    ScoreCash(state, { payload }) {
      return {
        ...state,
        scoreCash: payload.data.score,
      };
    },
    scoreData(state, { payload }) {
      let items: any[] = payload.data.data;
      if (payload.data.data && payload.page > 1) {
        items = [...state.data, ...payload.data.data];
      }
      if (payload.page === state.page && payload.page > 1) {
        items = [...state.data];
      }
      return {
        ...state,
        data: items,
        total_num: payload.data.total_num,
        page: payload.page,
        perpage: payload.perpage,
      };
    },
    changeCourseId(state, { payload }) {
      return {
        ...state,
        course_id: payload.data.id,
        mobile: payload.mobile,
      };
    },
  },
};

export default Model;
